import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ role, children }) => {
    const { auth } = useContext(AuthContext);

    // Check if neither user nor admin is authenticated
    if (!auth.isAuthenticated && !auth.isAdminAuthenticated && !auth.isVerifierAuthenticated) {
        return <Navigate to={role === 'admin' ? '/admin/login' : role === 'verifier' ? '/cv/login' : '/login'} replace />;
    }

    // Role-based protection
    if (auth.role !== role) {
        return <Navigate to="/unauthorized" replace />;
    }

    // If authenticated and role matches, render the component
    return children;
};

export default ProtectedRoute;
